import Vue       from 'vue';
import VueRouter from 'vue-router';

// Middleware
import {requireGuest, requireAuth} from './middleware';

// Views
import Home from './views/Home.vue';
import LoginCordova from './views/LoginCordova.vue';
import About from './views/About.vue';
import Contact from './views/Contact.vue';
import FoodSpirals from './views/FoodSpirals.vue';
import FitnessSpirals from './views/FitnessSpirals.vue';
import Blog from './views/Blog.vue';
import Post from './views/Post.vue';
import Recipes from './views/Recipes.vue';
import Recipe from './views/Recipe.vue';
import Events from './views/Events.vue';
import Login from './views/Login.vue';
import LoginCore from './views/LoginCore.vue';
import Account from './views/Account.vue';
import Profile from './views/Profile.vue';
import HealthData from './views/HealthData.vue';
import Scorecard from './views/Scorecard.vue';
import ScorecardOverview from './views/ScorecardOverview.vue';
import ScorecardEating from './views/ScorecardEating.vue';
import ScorecardExercise from './views/ScorecardExercise.vue';
import ScorecardLifestyle from './views/ScorecardLifestyle.vue';
import ScorecardMedical from './views/ScorecardMedical.vue';
import Signup from './views/Signup.vue';
import Signup_Individual from './views/Signup-Individual.vue';
import Signup_Professional from './views/Signup-Professional.vue';
import Signup_FoodService from './views/Signup-FoodService.vue';
import RegisterFree from './views/RegisterFree.vue';
import RegisterPaid from './views/RegisterPaid.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import ResetPassword from './views/ResetPassword.vue';
import Subscribe from './views/Subscribe.vue';
import Subscriptions from './views/Subscriptions.vue';
import UpdatePayment from './views/SubscriptionUpdatePayment.vue';
import IndividualResources from './views/IndividualResources';
import InstructorResources from './views/InstructorResources';
import FoodSearch from './views/FoodSearch';
import FoodGroups from './views/FoodGroups';
import MyFavorites from './views/MyFavorites';
import MyRecipes from './views/MyRecipes';
import FFFRecipes from './views/FFFRecipes';
import RecipeMaker from './views/RecipeMaker';
import MealEntries from './views/MealEntries';
import FoodInsights from './views/FoodInsights';
import ProgressReports from './views/ProgressReports';
import Communications from './views/Communications';
import SharePortalProfile from './views/SharePortalProfile';
import FoodServiceResources from './views/FoodServiceResources';
import Privacy from './views/Privacy.vue';
import Definitions from './views/Definitions.vue';
import NoAccess from './views/NoAccess.vue';
import Debug from './views/Debug.vue';      // For debugging
import FrequentlyAskedQuestions from "./views/FrequentlyAskedQuestions";
import SharePortalLogin from "./views/SharePortalLogin.vue";

// Instruct vue to use router
Vue.use(VueRouter);

// console.log('routes.js v.1.0.0');   // For debug only

// Food Tracker routes
// Note: Active `/parent/child` route will automatically highlight route `/parent`
const foodTrackerRoutes = [
  {
    path: 'food-tracker',
    name: 'food-tracker',
    component: MealEntries,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-tracker'
    },
  },
  {
    path: 'food-tracker/meal-entries',
    name: 'meal-entries',
    component: MealEntries,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-tracker'
    },
  },
  {
    path: 'food-tracker/food-insights',
    name: 'food-insights',
    component: FoodInsights,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-tracker'
    },
  },
  {
    path: 'food-tracker/progress-reports',
    name: 'progress-reports',
    component: ProgressReports,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-tracker'
    }
  },
];

// Shared Portal routes
const sharedPortalRoutes = [
  {
    path: 'share-portal',
    name: 'share-portal',
    component: SharePortalProfile,
    meta: {
      // permission: 'access-share-portal'
    },
  },
  {
    path: 'share-portal/profile',
    name: 'share-portal-profile',
    component: SharePortalProfile,
    meta: {
      // permission: 'access-share-portal'
    },
  },
  {
    path: 'share-portal/meal-entries',
    name: 'share-portal-meal-entries',
    component: MealEntries,
    meta: {
      // permission: 'access-share-portal'
    },
  },
  {
    path: 'share-portal/food-insights',
    name: 'share-portal-food-insights',
    component: FoodInsights,
    meta: {
      // permission: 'access-share-portal'
    },
  },
  {
    path: 'share-portal/progress-reports',
    name: 'share-portal-progress-reports',
    component: ProgressReports,
    meta: {
      // permission: 'access-share-portal'
    }
  },
];

// Food Database routes
const foodDatabaseRoutes = [
  {
    path: 'food-database',
    name: 'food-database',
    component: FoodSearch,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-database'
    },
  },
  {
    path: 'food-database/food-search',
    name: 'food-search',
    component: FoodSearch,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-database'
    },
  },
  {
    path: 'food-database/food-groups',
    name: 'food-groups',
    component: FoodGroups,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-database'
    }
  },
  {
    path: 'food-database/my-favorites',
    name: 'my-favorites',
    component: MyFavorites,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-database'
    },
  },
  {
    path: 'food-database/recipe-maker',
    name: 'recipe-maker',
    component: RecipeMaker,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-database'
    },
  },
  {
    path: 'food-database/fff-recipes',
    name: 'fff-recipes',
    component: FFFRecipes,
    beforeEnter: requireAuth,
    meta: {
      permission: 'access-food-database'
    },
  },
];

// Define routes
const router = new VueRouter({
  linkActiveClass: "active",
  mode: 'history',
  base: '/',
  fallback: true,
  scrollBehavior(to, from, savedPosition){
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    ...(window.IS_CORDOVA ? [
      {
        path: '/',
        name: 'home',
        redirect: { name: 'login' },
      },
    ] : [
      {
        path: '/',
        name: 'home',
        component: Home
      },
    ]),
    {
      path: '/account/share-portal/login',
      name: 'share-portal-login',
      component: SharePortalLogin,
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/food-spirals',
      name: 'food-spirals',
      component: FoodSpirals
    },
    {
      path: '/fitness-spirals',
      name: 'fitness-spirals',
      component: FitnessSpirals
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/blog/:post',
      name: 'post',
      component: Post
    },
    {
      path: '/recipes',
      name: 'recipes',
      component: Recipes
    },
    {
      path: '/recipe/:recipe',
      name: 'recipe',
      component: Recipe
    },
    {
      path: '/events',
      name: 'events',
      component: Events
    },
    {
      path: '/faq',
      name: 'faq',
      component: FrequentlyAskedQuestions,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/definitions',
      name: 'definitions',
      component: Definitions
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/signup/individual',
      name: 'signup.individual',
      component: Signup_Individual
    },
    {
      path: '/signup/professional',
      name: 'signup.professional',
      component: Signup_Professional
    },
    {
      path: '/signup/foodservice',
      name: 'signup.foodservice',
      component: Signup_FoodService
    },
    {
      path: '/register-free',
      name: 'register-free',
      component: RegisterFree
    },
    {
      path: '/register-paid/:type',
      name: 'register-paid',
      component: RegisterPaid,
      meta: {
        cordova_new_window: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: window.IS_CORDOVA ? LoginCordova : Login,
      beforeEnter: requireGuest
    },
    {
      path: '/logincore',
      name: 'logincore',
      component: LoginCore,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      beforeEnter: requireGuest
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword,
      beforeEnter: requireGuest
    },
    {
      path: '/account',
      component: Account,
      //beforeEnter: requireAuth,
      children: [
        {
          path: '/no-access',
          name: 'no-access',
          component: NoAccess,
          //beforeEnter: requireGuest
        },
        {
          path: 'profile',
          name: 'profile',
          beforeEnter: requireAuth,
          component: Profile
        },
        ...foodDatabaseRoutes,
        ...foodTrackerRoutes,
        ...sharedPortalRoutes,
        {
          path: 'health-data',
          name: 'health-data',
          component: HealthData,
          meta: {
            allow_guest: true,
          },
        },
        {
          path: 'scorecard',
          component: Scorecard,
          meta: {
            allow_guest: true,
          },
          children: [
            {
              path: '',
              name: 'scorecard',
              component: ScorecardOverview,
              meta: {
                allow_guest: true,
              },
            },
            {
              path: 'eating',
              name: 'scorecard.eating',
              component: ScorecardEating,
              meta: {
                allow_guest: true,
              },
            },
            {
              path: 'exercise',
              name: 'scorecard.exercise',
              component: ScorecardExercise,
              meta: {
                allow_guest: true,
              },
            },
            {
              path: 'lifestyle',
              name: 'scorecard.lifestyle',
              component: ScorecardLifestyle,
              meta: {
                allow_guest: true,
              },
            },
            {
              path: 'medical',
              name: 'scorecard.medical',
              component: ScorecardMedical,
              meta: {
                allow_guest: true,
              },
            }
          ]
        },
        {
          path: 'resources',
          name: 'resources',
          component: IndividualResources,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-individual-resources'
          }
        },
        {
          path: 'instructor-resources',
          name: 'instructor-resources',
          component: InstructorResources,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-instructor-resources'
          }
        },
        {
          path: 'my-recipes',
          name: 'my-recipes',
          component: MyRecipes,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-food-search'
          }
        },
        {
          path: 'communications',
          name: 'communications',
          component: Communications,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-communications'
          }
        },
        {
          path: 'food-service-resources',
          name: 'food-service-resources',
          component: FoodServiceResources,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-food-service-resources'
          }
        },
        {
          path: 'subscribe/:type',
          name: 'subscribe',
          component: Subscribe,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-subscriptions',
            cordova_new_window: true,
          }
        },
        {
          path: 'update-payment',
          name: 'update-payment',
          component: UpdatePayment,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-subscriptions'
          }
        },
        {
          path: 'subscriptions',
          name: 'subscriptions',
          component: Subscriptions,
          beforeEnter: requireAuth,
          meta: {
            permission: 'access-subscriptions'
          }
        }
      ]
    },

    {
      path: '/debug',
      name: 'debug',
      component: Debug,
    },

    // Catchall
    { path: '*', redirect: '/' },
  ]
});

// Export router
export default router;
